import type { TranslationBundle } from '@bms/common';

/**
 * The `search` namespace: the desk's one search (audit P5) — the header field,
 * the Ctrl+K palette over rooms, guests in house, cards and visitors, and the
 * card words the tap sentence is built from. Keys are read as `search.<key>`.
 */
export const search: TranslationBundle = {
  en: {
    title: 'Search the desk',
    placeholder: 'Room, guest, card, visitor',
    fieldAria: 'Search rooms, guests, cards and visitors',
    openAria: 'Open search',
    inputAria: 'Search rooms, guests in house, cards and visitors',
    shortcut: 'Ctrl K',
    shortcutMac: '⌘ K',
    escape: 'Esc',
    tabKey: 'Tab',
    hintMove: 'move',
    hintOpen: 'open',
    hintActions: 'actions',
    empty: 'Type a room, a guest, a card holder or a visitor.',
    noMatches: 'Nothing matches “{{query}}”.',
    loading: 'Searching…',
    group: {
      tapped: 'Tapped card',
      stays: 'Guests in house',
      rooms: 'Rooms',
      cards: 'Cards',
      visits: 'Visitors',
    },
    action: {
      checkIn: 'Check in',
      openStay: 'Open stay',
      openRoom: 'Open room',
      climate: 'Climate',
      doorKeys: 'Door & keys',
      openCard: 'Open card',
      openVisit: 'Open visit',
    },
    stay: {
      title: '{{guest}} · {{room}}',
      overdue: 'Overdue checkout, due {{time}}',
      due: 'Checkout {{time}}',
      noCheckout: 'No checkout time',
      keys_one: '{{count}} key active',
      keys_other: '{{count}} keys active',
      unnamedGuest: 'Guest',
    },
    room: {
      reading: '{{temperature}} / {{setpoint}} °C',
      temperature: '{{temperature}} °C',
    },
    card: {
      noHolder: 'No holder',
      until: 'until {{time}}',
      room: 'room {{room}}',
    },
    cardType: {
      guest: 'Guest card',
      staff: 'Staff card',
      service: 'Service card',
      master: 'Master card',
      temporary: 'Temporary card',
    },
    cardStatus: {
      pending: 'waiting to be written',
      active: 'active',
      suspended: 'suspended',
      revoked: 'revoked',
      not_yet_valid: 'not valid yet',
      expired: 'expired',
    },
    visit: {
      window: 'visit {{day}} {{from}}–{{until}}',
      checkedIn: 'checked in',
    },
    day: {
      today: 'today',
      tomorrow: 'tomorrow',
      yesterday: 'yesterday',
    },
  },
  hr: {
    title: 'Pretraga recepcije',
    placeholder: 'Soba, gost, kartica, posjetitelj',
    fieldAria: 'Pretraži sobe, goste, kartice i posjetitelje',
    openAria: 'Otvori pretragu',
    inputAria: 'Pretraži sobe, goste u hotelu, kartice i posjetitelje',
    shortcut: 'Ctrl K',
    shortcutMac: '⌘ K',
    escape: 'Esc',
    tabKey: 'Tab',
    hintMove: 'pomak',
    hintOpen: 'otvori',
    hintActions: 'radnje',
    empty: 'Upišite sobu, gosta, vlasnika kartice ili posjetitelja.',
    noMatches: 'Ništa ne odgovara „{{query}}”.',
    loading: 'Pretraživanje…',
    group: {
      tapped: 'Očitana kartica',
      stays: 'Gosti u hotelu',
      rooms: 'Sobe',
      cards: 'Kartice',
      visits: 'Posjetitelji',
    },
    action: {
      checkIn: 'Prijavi gosta',
      openStay: 'Otvori boravak',
      openRoom: 'Otvori sobu',
      climate: 'Klima',
      doorKeys: 'Vrata i ključevi',
      openCard: 'Otvori karticu',
      openVisit: 'Otvori posjet',
    },
    stay: {
      title: '{{guest}} · {{room}}',
      overdue: 'Kasni s odjavom, rok {{time}}',
      due: 'Odjava {{time}}',
      noCheckout: 'Bez vremena odjave',
      keys_one: '{{count}} aktivan ključ',
      keys_few: '{{count}} aktivna ključa',
      keys_other: '{{count}} aktivnih ključeva',
      unnamedGuest: 'Gost',
    },
    room: {
      reading: '{{temperature}} / {{setpoint}} °C',
      temperature: '{{temperature}} °C',
    },
    card: {
      noHolder: 'Bez vlasnika',
      until: 'do {{time}}',
      room: 'soba {{room}}',
    },
    cardType: {
      guest: 'Kartica gosta',
      staff: 'Kartica osoblja',
      service: 'Servisna kartica',
      master: 'Glavna kartica',
      temporary: 'Privremena kartica',
    },
    cardStatus: {
      pending: 'čeka zapisivanje',
      active: 'aktivna',
      suspended: 'suspendirana',
      revoked: 'opozvana',
      not_yet_valid: 'još nije važeća',
      expired: 'istekla',
    },
    visit: {
      window: 'posjet {{day}} {{from}}–{{until}}',
      checkedIn: 'prijavljen',
    },
    day: {
      today: 'danas',
      tomorrow: 'sutra',
      yesterday: 'jučer',
    },
  },
};
